export default function applyStyle ($el, style) {
  Object.keys(style).forEach(prop => {
    $el.style[prop] = style[prop]
  })
}



// WEBPACK FOOTER //
// ./src/js/util/applyStyle.js